import { render, staticRenderFns } from "./JobPage.vue?vue&type=template&id=2b0d49da"
import script from "./JobPage.vue?vue&type=script&lang=js"
export * from "./JobPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports